import styles from "../../styles/nature/Nature.module.css";

import MobileSearchPage from "@/components/publicProfiles/Header/MobileSearchPage";
import ProfileHeader from "@/components/publicProfiles/Header/ProfileHeader";
import BreadCrumbs from "@/components/shared/breadCrumbs/BreadCrumbs";
import NatureRectangle from "@/components/traits/nature/NatureRectangle";
import { usePublicProfileContext } from "@/context/PublicProfileContext";
import { natureData } from "@/assets/traitInfo/natureData";
import Footers from "@/components/shared/Footers/Footers";
import TraitsSEOHeader from "@/components/traits/shared/TraitsSEOHeader";
import LargeTraitsHeading from "@/components/traits/shared/LargeTraitsHeading/LargeTraitsHeading";

export default function NatureHomePage() {
  const { mobileSearchOpen } = usePublicProfileContext();

  return (
    <>
      <TraitsSEOHeader
        title={`Dimensional || Natures`}
        description="Almost every Element in the Dimensional Personality Test belongs to
        one of 7 “Natures.” An Element's Nature is its underlying essence.
        Similarly after completing the Core Dimensions, every Dimensional
        user unlocks their Primary Nature: the nature that most reflects
        their essence based on their scores on the underlying Elements."
      />
      {mobileSearchOpen === true && <MobileSearchPage />}
      <ProfileHeader />
      <div className={styles.main}>
        <div className={styles.top}>
          <BreadCrumbs list={["Nature"]} urls={[]} />
          <LargeTraitsHeading title="Natures" />
          <p className={styles.subHeading}>
            Almost every Element in the Dimensional Personality Test belongs to
            one of 7 “Natures.” An Element’s Nature is its underlying essence.
            Similarly after completing the Core Dimensions, every Dimensional
            user unlocks their Primary Nature: the nature that most reflects
            their essence based on their scores on the underlying Elements.
          </p>
        </div>
        <div className={styles.parent}>
          {natureData.map((el, index) => {
            return (
              <NatureRectangle
                color={el.color}
                name={el.name}
                slug={el.slug}
                key={index}
              />
            );
          })}
        </div>
      </div>
      <Footers />
    </>
  );
}
